import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import useStyles from './styles';
import Stepper from '@material-ui/core/Stepper';
import { Button, CircularProgress } from '@material-ui/core';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { useIntl } from 'react-intl';
import clsx from 'clsx';

const HorizontalSteps = (props) => {
  const {steps, activeStep, handleNext, handlePrevious, handleSKip, children, showLoader} = props;
  const classes = useStyles();
  const intl = useIntl();

  const filteredSteps = (steps || []).filter(step => step.showStage);
  let activeStepIndex = filteredSteps.findIndex(step => step.id === activeStep);
  activeStepIndex = activeStepIndex === -1 ? 0 : activeStepIndex;
  const activeStepObj = filteredSteps[activeStepIndex];

  const handlePreviousButtonClick = () => {
    handlePrevious(activeStepObj);
  }

  const handleNextButtonClick = () => {
    handleNext(activeStepObj);
  }

  const handleSkipButtonClick = () => {
    handleSKip(activeStepObj);
  }

  return (
    <div className={classes.root}>
      <div className={classes.timeline}>
        <Stepper activeStep={activeStepIndex} alternativeLabel>
          {filteredSteps.map(stepObj => (
            <Step key={stepObj.id}>
              <StepLabel>
                {intl.formatMessage({id: stepObj.title, defaultMessage: stepObj.defaultTitle})}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className={clsx(classes.contentArea, showLoader && classes.justifyCenter)}>
        {
          showLoader ? <CircularProgress/> : children
        }
      </div>
      <div className={classes.actionArea}>
        {
          !showLoader &&
          <Grid container spacing={3}>
            <Grid item xs={8}>
              {
                activeStepObj.showPrevious &&
                <Button onClick={handlePreviousButtonClick} color={'primary'} className={classes.button}>
                  {intl.formatMessage({id: "horizontal.steps.action.previous", defaultMessage: "Previous"})}
                </Button>
              }
            </Grid>
            <Grid item xs={2} className={classes.justifyCenter}>
              {
                activeStepObj.showSkip &&
                <Button onClick={handleSkipButtonClick} color={'primary'} className={classes.button}>
                  {intl.formatMessage({id: "horizontal.steps.action.skip", defaultMessage: "Skip"})}
                </Button>
              }
            </Grid>
            <Grid item xs={2} className={classes.justifyCenter}>
              {
                activeStepObj.showNext &&
                <Button onClick={handleNextButtonClick} color={'primary'} className={classes.button}>
                  {intl.formatMessage({id: "horizontal.steps.action.next", defaultMessage: "Next"})}
                </Button>
              }
            </Grid>
          </Grid>
        }
      </div>
    </div>
  );
}

HorizontalSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      defaultTitle: PropTypes.string.isRequired,
      showStage: PropTypes.bool,
      showNext: PropTypes.bool,
      showPrevious: PropTypes.bool,
      showSkip: PropTypes.bool
    }),
  ),
  activeStep: PropTypes.string,
  handleNext: PropTypes.func,
  handlePrevious: PropTypes.func,
  handleSKip: PropTypes.func,
  showLoader: PropTypes.bool
};

const doNothing = () => {};

HorizontalSteps.defaultProps = {
  steps: [],
  activeStep: '',
  handleNext: doNothing,
  handlePrevious: doNothing,
  handleSKip: doNothing,
  showLoader: false
}

export default HorizontalSteps;